module.exports = __webpack_public_path__ + "static/media/IMG_20181114_212536.7d2e48be.jpg";